module.exports = "/assets/image-right@2x.jpg?I9ZEwQY";